import React from 'react'
import { Toolbox } from './Toolbox'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxBodyCell, DataTable, RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import { useProductSelectListContext } from './Context'
import { ListHeader } from './ListHeader'
import { ProductRenderDataBodyCellConfig } from '../ProductList/ProductListRow'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'

export const Layout = () => {
  const context = useProductSelectListContext()

  const { components, productList, listWithSelection, listFieldConfig } = context
  const { list } = listWithSelection
  const defaultListResult = { ...productList, list }
  return (
    <>
      <div>
        <Toolbox />
        <DataTable
          height={'50vh'}
          fields={listFieldConfig}
          name="product-select-list-v1"
          listResult={defaultListResult}
          row={ListRow}
          stats="products"
          head={ListHeader}
        />
      </div>
      <div className={'py-2'}>
        <components.ActionButtons {...context} />
      </div>
    </>
  )
}

const ListRow = (props: BodyRowConfig<EntityWithSelection<Product>>) => {
  const context = useProductSelectListContext()
  const { toggleSelectBy } = context.listWithSelection
  const { _id, _selected } = props
  const productRenderDataBodyCellConfig = ProductRenderDataBodyCellConfig({ ...props })

  return (
    <>
      <RowNumberBodyCell {...props} />
      <CheckboxBodyCell
        checked={_selected}
        onChange={() => {
          toggleSelectBy((item) => item._id === _id)
        }}
      />

      {props._renderDataBodyCell(productRenderDataBodyCellConfig)}
    </>
  )
}
